import {combineReducers} from 'redux'
import AuthReducer from './AuthReducer'
import AppLoadReducer from './AppLoadReducer'
import DataReducer from './DataReducer'
import SettingsReducer from './SettingsReducer'
import FreeReducer from './FreeReducer'
import StarsReducer from './StarsReducer'
import GiftHallReducer from './GiftHallReducer'
import QuestionNumberReducer from './QuestionNumberReducer'
import CoinTypeVisibleReducer from './CoinTypeVisibleReducer'
import DialogReducer from './DialogReducer'
export  default combineReducers({
    Auth:AuthReducer,
    AppLoad:AppLoadReducer,
    UserData:DataReducer,
    Settings:SettingsReducer,
    Free:FreeReducer,
    Stars:StarsReducer,
    GiftHall:GiftHallReducer,
    QuestionNumber:QuestionNumberReducer,
    CoinTypeVisible:CoinTypeVisibleReducer,
    Dialog:DialogReducer,
})